import React, { Component } from 'react';
import { isAbsolute } from '../../../../backoffice/scripts/zzcustom_indexeddbshim';


export default class WorkspaceFilterDropDown extends Component {


    constructor(props) {

        super(props);

        //window.workspaceFilterDropDown = this;

        this.state = {
            rows: [],
            renderedRows: [],
            scrollPosition: 0,
            selectAll: "Yes",
            filteredFilters: {},
            search: "",
        };

        this.renderedRowCnt = 25;


        this.renderRows = this.renderRows.bind(this);
        this.renderRowsAlternateWay = this.renderRowsAlternateWay.bind(this);
        this.handleScrollEvent = this.handleScrollEvent.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.deSelectAll = this.deSelectAll.bind(this);
        this.makeSelection = this.makeSelection.bind(this);
        this.isFilterEnabled = this.isFilterEnabled.bind(this);
        this.searchFilters = this.searchFilters.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
    }

    componentDidMount() {
        this.setState({ filteredFilters: this.props.filter })
    }

    componentDidUpdate() {
        if( this.props.filter.selected.length !== this.state.filteredFilters.selected.length) {
            if(this.props.filter.options.length > 0 && this.state.filteredFilters.options.length === 0) {
                let selected = {
                    ...this.state.filteredFilters,
                    selected: [...this.props.filter.selected],
                    options: [...this.props.filter.options]
                }
                this.setState({filteredFilters: selected});
            } else {
                let selected = {
                    ...this.state.filteredFilters,
                    selected: [...this.props.filter.selected],
                    options: [...this.state.filteredFilters.options]
                }
                this.setState({filteredFilters: selected});
            }
        }
        if(this.state.filteredFilters.options.length === this.state.filteredFilters.selected.length && this.state.selectAll !== "Yes") {
            this.setState({selectAll: "Yes"})
        } else if(this.state.filteredFilters.options.length > this.state.filteredFilters.selected.length && this.state.filteredFilters.selected.length > 0 && this.state.selectAll !== "Intermediate") {
            this.setState({selectAll: "Intermediate"});
        } else if(this.state.filteredFilters.selected.length === 0 && this.state.filteredFilters.options.length !== 0 && this.state.selectAll !== "No") {
            this.setState({selectAll: "No"});
        }
    }

    renderRows() {

        let optionsJsx = [];
        let optionsJsxCount = 0;

        if (this.props.filter.options.length > 0 && typeof this.props.filter.options[0] === "object") {

            this.props.filter.options.forEach(op => {

                let isExpanded = this.props.expandedFilterMajors.includes(op.value)
                let fillStateClass = "";
                if (op.selected.length === op.options.length) {
                    fillStateClass = " selected"
                }

                optionsJsx.push((
                    <div
                        className={"option-major" + (isExpanded ? " expanded" : "") + (op.selected.length > 0 ? " selected" : "")}
                    >
                        <div className={"material-icons drop-down"} onClick={this.props.expandFilterMajor.bind(null, op.value)}>{"chevron_right"}</div>
                        <div className={"checkbox"} onClick={this.props.makeFilterMajorSelection.bind(null, op.value, this.props.filterKey)}>
                            <div className={"material-icons check"}>{op.selected.length > 0 && op.selected.length != op.options.length ? "remove" : "check"}</div>
                        </div>
                        <div className={"option-label"}>{`${op.label} (${op.selected.length}/${op.options.length})`}</div>
                    </div>
                ));

                optionsJsxCount++;
                if (isExpanded) {
                    optionsJsxCount += op.options.length;
                }

                op.options.forEach(sub => {
                    optionsJsx.push((
                        <div
                            className={"option-simple indented" + (this.props.filter.selected.includes(sub) ? " selected" : "") + (isExpanded ? "" : " hidden")}
                            onClick={this.props.makeFilterSelection.bind(null, sub, this.props.filterKey)}
                        >
                            <div className={"checkbox"}>
                                <div className={"material-icons check"}>{"check"}</div>
                            </div>
                            <div className={"option-label"}>
                                {this.props.filter.map != null && this.props.filter.map != undefined &&
                                    this.props.allMaps[this.props.filter.map] != undefined && this.props.allMaps[this.props.filter.map][sub] != undefined ? this.props.allMaps[this.props.filter.map][sub] : sub}
                            </div>
                        </div>
                    ));
                })
            });

        } else {
            let useMap = this.props.filter.map != null && this.props.filter.map != undefined &&
                this.props.allMaps[this.props.filter.map] != undefined;

            _.sortBy(this.props.filter.options, op => (useMap && this.props.allMaps[this.props.filter.map][op] != undefined ? this.props.allMaps[this.props.filter.map][op] : op).toString().toUpperCase()).forEach(op => {
                optionsJsxCount++;
                optionsJsx.push((
                    <div
                        className={"option-simple" + (this.props.filter.selected.includes(op) ? " selected" : "")}
                        onClick={this.props.makeFilterSelection.bind(null, op, this.props.filterKey)}
                    >
                        <div className={"checkbox"}>
                            <div className={"material-icons check"}>{"check"}</div>
                        </div>
                        <div className={"option-label"}>
                            {useMap && this.props.allMaps[this.props.filter.map][op] != undefined ? this.props.allMaps[this.props.filter.map][op] : op}
                        </div>
                    </div>
                ));
            });
        }

        let denominator = this.props.filter.options.length;
        if (this.props.filter.options.length > 0 && typeof this.props.filter.options[0] === "object") {
            denominator = 0;
            this.props.filter.options.forEach(op => { denominator += op.options.length })
        }

        // // let optionsContainerStyle = {};
        // // if (this.props.activeFilter === this.props.filterKey && optionsJsxCount < 6) {
        // //     optionsContainerStyle.height = (optionsJsxCount * 3) + 'rem';
        // // }

        // // this.setState({ optionsContainerStyle: optionsContainerStyle });

        //TODO: test
        // if (denominator > 0) {
        //     result.push((
        //         <div
        //             key={`left-nav-filter-${key}`}
        //             className={"filter-container" + (this.props.activeFilter === key ? " active" : "")}
        //         >
        //             <div className={"label"} onClick={this.props.setActiveFilter.bind(null, key)}>{`${f.label}`}<span>{` (${f.selected.length}/${denominator})`}</span></div>
        //             <div className={"material-icons drop-icon"} onClick={this.props.setActiveFilter.bind(null, key)}>{"arrow_drop_down"}</div>
        //             <div className={"options-container"} style={optionsContainerStyle}>
        //                 {this.props.isOpen ? optionsJsx : null}
        //             </div>
        //             <div className={"off-clicker"} onClick={this.props.setActiveFilter.bind(null, null)}></div>
        //         </div>
        //     ))
        // }

        return optionsJsx;

    }

    isFilterEnabled() {
        if (this.props.activeWorkspaceId > 0) {
            return true;
        }
        else {
            if (this.props.filterKey === 'storeId' || this.props.filterKey === 'onlineStoreId') {
                return true;
            }
        }
        return false;
    }

    searchFilters(val) {
        let filteredFilters = [];
        const type = this.props.filter.map
        filteredFilters = this.props.filter.options.filter((el) => {
            return this.props.allMaps[type][el].toLowerCase().includes(val.toLowerCase());
        })
        const filter = {
            ...this.props.filter,
            options: filteredFilters,
            selected: [...this.props.filter.selected]
        }
        this.setState({ filteredFilters: filter, search: val });
    }

    clearSearch() {
        const filter = {
            ...this.props.filter,
            options: [...this.props.filter.options],
            selected: [...this.props.filter.selected]
        }
        this.setState({ filteredFilters: filter, search: "" });
    }

    selectAll() {
        this.setState({ selectAll: "Yes" });
        this.props.selectAllFilters(this.props.filterKey, this.state.filteredFilters.options);
    }

    deSelectAll() {
        this.setState({ selectAll: "No" });
        this.props.deSelectAllFilters(this.props.filterKey, this.state.filteredFilters.options);
    }

    makeSelection(op) {
        if (this.props.filter.options.length === this.props.filter.selected.length) {
            this.setState({ selectAll: "Intermediate" });
            this.props.makeFilterSelection.call(null, op, this.props.filterKey);
        }
        else if (this.props.filter.options.length - 1 === this.props.filter.selected.length && !this.props.filter.selected.includes(op)) {
            this.setState({ selectAll: "Yes" });
            this.props.makeFilterSelection.call(null, op, this.props.filterKey);
        }
        else if (this.props.filter.selected.length === 1 && this.props.filter.selected.includes(op)) {
            this.setState({ selectAll: "No" });
            this.props.makeFilterSelection.call(null, op, this.props.filterKey);
        }
        else if (this.props.filter.options.length > this.props.filter.selected.length) {
            this.setState({ selectAll: "Intermediate" });
            this.props.makeFilterSelection.call(null, op, this.props.filterKey);
        }
        else {
            this.props.makeFilterSelection.call(null, op, this.props.filterKey);
        }
    }

    checkStatus() {
        let status = true;
        if(this.state.filteredFilters.options !== undefined) {
            this.state.filteredFilters.options.forEach(option => {
                if(!this.state.filteredFilters.selected.includes(option)) {
                    status = false;
                }
            })
        }
        return status;
    }


    intermediateStatus() {
        let intermediateStat = 0;
        if(this.state.filteredFilters.options !== undefined) {
            this.state.filteredFilters.options.forEach(option => {
                if(this.state.filteredFilters.selected.includes(option)) {
                    intermediateStat += 1;
                }
            })
            if(intermediateStat === this.state.filteredFilters.options.length) {
                return false;
            } else if(intermediateStat > 0 && intermediateStat < this.state.filteredFilters.options.length) {
                return true;
            }
        }
        return false;
    }

    isCheckboxSelected() {
        let status = false;
        if(this.state.filteredFilters.options !== undefined) {
            this.state.filteredFilters.options.forEach(option => {
                if(this.state.filteredFilters.selected.includes(option)) {
                    status = true;
                }
            })
        }
        return status;
    }

    renderRowsAlternateWay() {

        let threshHoldRows = [];
        let optionsJsx = [];
        let optionsJsxCount = 0;
        if (this.state.scrollPosition === 0) {
            optionsJsx.push(
                (<div
                    className={"option-simple" + " searchBox" + (!this.isCheckboxSelected() ? "" : " selected")}
                >
                    <div className={"checkbox"} onClick={this.state.selectAll === "Yes" ? () => this.deSelectAll() : () => this.selectAll()}>
                        <div className={"material-icons" + " check" + (this.checkStatus() ? "" : " dispNone")}>{"check"}</div>
                        <div className={"material-icons" + " check" + (this.intermediateStatus() ? "" : " dispNone")}>{"remove"}</div>
                    </div>
                    <div className={"searchDiv"}><input value={this.state.search} onChange={(e) => this.searchFilters(e.target.value)} className={"searchField"} placeholder={"Search.."}></input></div>
                    <div className={"clearBtn"} onClick={() => this.clearSearch()}>
                        <div className={"material-icons"}>{"clear"}</div>
                    </div>
                </div>
                )
            )
            optionsJsxCount++;
        }

        if (this.state.filteredFilters > 0 && typeof this.state.filteredFilters.options[0] === "object") {

            // this.props.filter.options.forEach(op => {

            //     let isExpanded = this.props.expandedFilterMajors.includes(op.value)
            //     let fillStateClass = "";
            //     if (op.selected.length === op.options.length) {
            //         fillStateClass = " selected"
            //     }

            //     optionsJsx.push((
            //         <div
            //             className={"option-major" + (isExpanded ? " expanded" : "") + (op.selected.length > 0 ? " selected" : "")}
            //         >
            //             <div className={"material-icons drop-down"} onClick={this.props.expandFilterMajor.bind(null, op.value)}>{"chevron_right"}</div>
            //             <div className={"checkbox"} onClick={this.props.makeFilterMajorSelection.bind(null, op.value, this.props.filterKey)}>
            //                 <div className={"material-icons check"}>{op.selected.length > 0 && op.selected.length != op.options.length ? "remove" : "check"}</div>
            //             </div>
            //             <div className={"option-label"}>{`${op.label} (${op.selected.length}/${op.options.length})`}</div>
            //         </div>
            //     ));

            //     optionsJsxCount++;
            //     if (isExpanded) {
            //         optionsJsxCount += op.options.length;
            //     }

            //     op.options.forEach(sub => {
            //         optionsJsx.push((
            //             <div
            //                 className={"option-simple indented" + (this.props.filter.selected.includes(sub) ? " selected" : "") + (isExpanded ? "" : " hidden")}
            //                 onClick={this.props.makeFilterSelection.bind(null, sub, this.props.filterKey)}
            //             >
            //                 <div className={"checkbox"}>
            //                     <div className={"material-icons check"}>{"check"}</div>
            //                 </div>
            //                 <div className={"option-label"}>
            //                     {this.props.filter.map != null && this.props.filter.map != undefined &&
            //                         this.props.allMaps[this.props.filter.map] != undefined && this.props.allMaps[this.props.filter.map][sub] != undefined ? this.props.allMaps[this.props.filter.map][sub] : sub}
            //                 </div>
            //             </div>
            //         ));
            //     })
            // });

            for (var i = 0 + this.state.scrollPosition; i < this.renderedRowCnt + this.state.scrollPosition; i++) {
                //for (var i = 0; i < this.props.filter.options.length; i++) {

                let op = this.state.filteredFilters.options[i];
                let isExpanded = this.props.expandedFilterMajors.includes(this.state.filteredFilters.options[i].value)
                let fillStateClass = "";
                if (this.state.filteredFilters.options[i].selected.length === this.state.filteredFilters.options[i].options.length) {
                    fillStateClass = " selected"
                }

                optionsJsx.push((
                    <div
                        className={"option-major" + (isExpanded ? " expanded" : "") + (op.selected.length > 0 ? " selected" : "")}
                    >
                        <div className={"material-icons drop-down"} onClick={this.props.expandFilterMajor.bind(null, op.value)}>{"chevron_right"}</div>
                        <div className={"checkbox"} onClick={this.props.makeFilterMajorSelection.bind(null, op.value, this.props.filterKey)}>
                            <div className={"material-icons check"}>{op.selected.length > 0 && op.selected.length != op.options.length ? "remove" : "check"}</div>
                        </div>
                        <div className={"option-label"}>{`${op.label} (${op.selected.length}/${op.options.length})`}</div>
                    </div>
                ));

                optionsJsxCount++;
                if (isExpanded) {
                    optionsJsxCount += this.state.filteredFilters.options[i].options.length;
                }

                for (var j = 0; j < op.options.length; j++) {
                    let sub = op.options[j];

                    optionsJsx.push((
                        <div
                            className={"option-simple indented" + (this.props.filter.selected.includes(sub) ? " selected" : "") + (isExpanded ? "" : " hidden")}
                            onClick={this.props.makeFilterSelection.bind(null, sub, this.props.filterKey)}
                        >
                            <div className={"checkbox"}>
                                <div className={"material-icons check"}>{"check"}</div>
                            </div>
                            <div className={"option-label"}>
                                {this.props.filter.map != null && this.props.filter.map != undefined &&
                                    this.props.allMaps[this.props.filter.map] != undefined && this.props.allMaps[this.props.filter.map][sub] != undefined ? this.props.allMaps[this.props.filter.map][sub] : sub}
                            </div>
                        </div>
                    ));
                }
            }

        } else {
            let useMap = this.state.filteredFilters.map != null && this.state.filteredFilters.map != undefined &&
                this.props.allMaps[this.state.filteredFilters.map] != undefined;

            let nonClassicalLoopIterator = 1;
            _.sortBy(this.state.filteredFilters.options, op => (useMap && this.props.allMaps[this.props.filter.map][op] != undefined ? this.props.allMaps[this.props.filter.map][op] : op).toString().toUpperCase()).forEach(op => {

                if (this.state.scrollPosition > 1 && this.state.scrollPosition < 10) {
                    if (nonClassicalLoopIterator >= 1 + this.state.scrollPosition - this.state.scrollPosition && nonClassicalLoopIterator < this.state.scrollPosition) {
                        optionsJsxCount++;
                        threshHoldRows.push((
                            <div
                                key={nonClassicalLoopIterator}
                                className={"option-simple" + (this.props.filter.selected.includes(op) ? " selected" : "")}
                                onClick={() => this.makeSelection(op)}
                            >
                                <div className={"checkbox"}>
                                    <div className={"material-icons check"}>{"check"}</div>
                                </div>
                                <div className={"option-label"}>
                                    {useMap && this.props.allMaps[this.props.filter.map][op] != undefined ? this.props.allMaps[this.props.filter.map][op] : op}
                                </div>
                            </div>
                        ));
                    }
                    if (nonClassicalLoopIterator >= this.state.scrollPosition && nonClassicalLoopIterator < this.state.scrollPosition + this.renderedRowCnt) {
                        optionsJsxCount++;
                        optionsJsx.push((
                            <div
                                key={nonClassicalLoopIterator}
                                className={"option-simple" + (this.props.filter.selected.includes(op) ? " selected" : "")}
                                onClick={() => this.makeSelection(op)}
                            >
                                <div className={"checkbox"}>
                                    <div className={"material-icons check"}>{"check"}</div>
                                </div>
                                <div className={"option-label"}>
                                    {useMap && this.props.allMaps[this.props.filter.map][op] != undefined ? this.props.allMaps[this.props.filter.map][op] : op}
                                </div>
                            </div>
                        ));
                    }
                } else if (this.state.scrollPosition >= 10) {

                    if (nonClassicalLoopIterator >= this.state.scrollPosition - 10 && nonClassicalLoopIterator < this.state.scrollPosition) {
                        optionsJsxCount++;
                        threshHoldRows.push((
                            <div
                                key={nonClassicalLoopIterator}
                                className={"option-simple" + (this.props.filter.selected.includes(op) ? " selected" : "")}
                                onClick={() => this.makeSelection(op)}
                            >
                                <div className={"checkbox"}>
                                    <div className={"material-icons check"}>{"check"}</div>
                                </div>
                                <div className={"option-label"}>
                                    {useMap && this.props.allMaps[this.props.filter.map][op] != undefined ? this.props.allMaps[this.props.filter.map][op] : op}
                                </div>
                            </div>
                        ));
                    }

                    if (nonClassicalLoopIterator >= this.state.scrollPosition && nonClassicalLoopIterator < this.state.scrollPosition + this.renderedRowCnt) {
                        optionsJsxCount++;
                        optionsJsx.push((
                            <div
                                key={nonClassicalLoopIterator}
                                className={"option-simple" + (this.props.filter.selected.includes(op) ? " selected" : "")}
                                onClick={() => this.makeSelection(op)}
                            >
                                <div className={"checkbox"}>
                                    <div className={"material-icons check"}>{"check"}</div>
                                </div>
                                <div className={"option-label"}>
                                    {useMap && this.props.allMaps[this.props.filter.map][op] != undefined ? this.props.allMaps[this.props.filter.map][op] : op}
                                </div>
                            </div>
                        ));
                    }

                } else {
                    if (nonClassicalLoopIterator >= this.state.scrollPosition && nonClassicalLoopIterator < this.state.scrollPosition + this.renderedRowCnt) {
                        optionsJsxCount++;
                        optionsJsx.push((
                            <div
                                key={nonClassicalLoopIterator}
                                className={"option-simple" + (this.props.filter.selected.includes(op) ? " selected" : "")}
                                onClick={() => this.makeSelection(op)}
                            >
                                <div className={"checkbox"}>
                                    <div className={"material-icons check"}>{"check"}</div>
                                </div>
                                <div className={"option-label"}>
                                    {useMap && this.props.allMaps[this.props.filter.map][op] != undefined ? this.props.allMaps[this.props.filter.map][op] : op}
                                </div>
                            </div>
                        ));
                    }
                }

                nonClassicalLoopIterator++;
            });
        }

        let rem = parseFloat(getComputedStyle(document.documentElement).fontSize);

        let totalRowElementsHeight
        if(this.state.filteredFilters.option !== undefined) {
            totalRowElementsHeight = this.state.filteredFilters.options.length;
        } else {
            totalRowElementsHeight = 1;
        }
        //let totalRowElementsHeight = this.state.filteredFilters.options.length;
        let totalRowHeightWrapper = { position: 'absolute', top: '0rem', left: '0rem', height: (totalRowElementsHeight * 3 * rem) + 'px', width: '100%' };
        let dynamicTopFiller = { position: 'relative', top: '0rem', left: '0rem', width: '100%', height: ((this.state.scrollPosition * rem * 3) - (threshHoldRows.length * rem * 3)) + 'px' };
        let dynamicBottomFiller = { position: 'relative', top: '0rem', left: '0rem', width: '100%', height: ((totalRowElementsHeight - this.state.scrollPosition - this.renderedRowCnt) * rem * 3) + 'px' };

        if (this.state.scrollPosition >= (totalRowElementsHeight - this.renderedRowCnt - 10)) {
            dynamicBottomFiller.height = '0px';
        }

        return (<div style={totalRowHeightWrapper}>
            <div style={dynamicTopFiller}></div>
            {threshHoldRows}
            {optionsJsx}
            <div style={dynamicBottomFiller}></div>
        </div>)

    }

    handleScrollEvent(e) {
        this.handleScroll(e.target.scrollTop);
    }

    async handleScroll(eventScrollTop) {

        let rem = parseFloat(getComputedStyle(document.documentElement).fontSize);

        this.setState({
            scrollPosition: Math.floor(eventScrollTop / (3 * rem))
        });
    }

    render() {

        let denominator;
        if(this.props.filter.options !== undefined) {
            denominator = this.props.filter.options.length;
        }
        let optionsJsxCount = 0;
        if(Object.keys(this.props.filter).length > 0 && Object.keys(this.state.filteredFilters).length === 0) {
            this.setState({ filteredFilters: this.props.filter })
        }
        if(this.props.filter.options !== undefined) {
            this.props.filter.options.forEach(op => {
                let isExpanded = this.props.expandedFilterMajors.includes(op.value);
                optionsJsxCount++;
                if (isExpanded) {
                    optionsJsxCount += op.options.length;
                }
            });
        }

        let optionsContainerStyle = {};
        if (this.props.activeFilter === this.props.filterKey && optionsJsxCount < 6 && this.state.filteredFilters.options.length > 1) {
            optionsContainerStyle.height = ((optionsJsxCount * 3) + 4.5) + 'rem';
        }
        else if (this.props.activeFilter === this.props.filterKey && optionsJsxCount < 6 && this.state.filteredFilters.options.length > 0) {
            optionsContainerStyle.height = (optionsJsxCount * 3 + 4.5) + 'rem';
        }
        else if(this.props.activeFilter === this.props.filterKey && optionsJsxCount < 6 && this.state.filteredFilters.options.length === 0) {
            optionsContainerStyle.height = (optionsJsxCount * 3) + 'rem';
        }

        return (<div
            key={`left-nav-filter-${this.props.filterKey}`} id = {this.props.filterKey} data-trackid={'filter-'+this.props.filterKey}
            className={this.isFilterEnabled() ? "filter-container" + (this.props.activeFilter === this.props.filterKey ? " active" : "") : "filter-container filter-disable"}
        >
            <div className={this.isFilterEnabled() ? "label" : "label cursor-disable"} onClick={ this.isFilterEnabled() ? this.props.setActiveFilter.bind(null, this.props.filterKey) : ''}>{`${this.props.filter.label === 'customerName' ? 'Customer' : this.props.filter.label}`}<span>{` (${this.props.filter.selected.length}/${denominator})`}</span></div>
            <div className={this.isFilterEnabled() ? "material-icons drop-icon" : "material-icons drop-icon cursor-disable"} onClick={(this.props.activeFilter === this.props.filterKey ? this.props.setActiveFilter.bind(null, null) : this.isFilterEnabled() ? this.props.setActiveFilter.bind(null, this.props.filterKey) : '')}>{"arrow_drop_down"}</div>
            <div className={"options-container"} style={optionsContainerStyle} onScroll={this.handleScrollEvent}>
                {this.props.isOpen ? this.renderRowsAlternateWay() : null}
            </div>
            <div className={"off-clicker"} onClick={this.props.setActiveFilter.bind(null, null)}></div>
        </div>)

    }

}